import type { NextPage } from "next";
import dynamic from "next/dynamic";

import NextSectionAction from "components/next-section-action";
import DigitalWelcomeCalls from "components/views/sales-process/digital-welcome-calls";

import Page from "../../components/layout/page";
import CustomerPortal from "../../components/views/sales-process/customer-portal";
import Designs from "../../components/views/sales-process/designs";
import Docflo from "../../components/views/sales-process/docflo";
import Financing from "../../components/views/sales-process/financing";
import MainHero from "../../components/views/sales-process/main-hero";
import ProjectManagement from "../../components/views/sales-process/project-management";
import ProjectSubmission from "../../components/views/sales-process/project-submission";
import Proposals from "../../components/views/sales-process/proposals";
import Qualification from "../../components/views/sales-process/qualification";
import SalesPipeline from "../../components/views/sales-process/sales-pipeline";
import Scheduling from "../../components/views/sales-process/scheduling";
import WhereverYourProcess from "../../components/views/sales-process/wherever-your-process";

const TimelineWave = dynamic(() => import("../../components/views/sales-process/timeline-wave"));
const DemoFormSection = dynamic(() => import("../../components/demo-form-section"));

const SalesProcess: NextPage = () => (
  <Page
    title="Enerflo Solar Software Platform Features | Sales Process"
    description="Enerflo offers the most unified solar sales process in the industry. One platform, one login, one seamless sales experience, start to finish."
  >
    <MainHero />
    <WhereverYourProcess />
    <div className="overflow-hidden relative bg-gray-100">
      <div className="relative z-10">
        <Qualification />
        <Scheduling />
        <SalesPipeline />
        <Designs />
        <Proposals />
        <Financing />
        <Docflo />
        <ProjectSubmission />
        <DigitalWelcomeCalls />
        <ProjectManagement />
        <CustomerPortal />
      </div>
      <TimelineWave />
    </div>
    <NextSectionAction
      buttonText="View Project Management"
      url="/features/project-management"
      description="See how Enerflo improves Project Management"
    />
    <DemoFormSection />
  </Page>
);

export default SalesProcess;
